'use client';

import { type PropsWithChildren } from 'react';

import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { useAnalytics } from '@/hooks/analytics';

export default function PrivacyPolicyLink({ children }: PropsWithChildren) {
	const { logEvent } = useAnalytics();
	const { authPrompt } = useAuthPrompt();

	return (
		<a
			href="/privacy"
			target="_blank"
			onClick={() =>
				logEvent({
					eventName: 'Login Form : Privacy Policy : Clicked',
					eventProps: {
						mode: authPrompt,
					},
				})
			}
		>
			{children}
		</a>
	);
}
